<template>
    <div v-show="show">
        <div class="modal-backdrop" />
        <section class="modal u-block" tabindex="-1" role="dialog">
            <global-events @keyup.esc="hide" />

            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
                <div class="modal-content" v-on-click-away="hide">
                    <div class="modal-header">
                        <h1 class="h5 modal-title">{{ headline }}</h1>
                        <button
                            v-if="closable"
                            type="button"
                            class="close u-reset-button"
                            data-dismiss="modal"
                            aria-label="Schließen"
                            @click="$emit('input', false)"
                        >
                            <app-icon name="x" hidden :scale="1.5" />
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot />
                    </div>
                    <div v-if="!hideFooter" class="modal-footer">
                        <slot name="footer" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { directive as onClickAway } from 'vue-clickaway'
import GlobalEvents from 'vue-global-events'
import AppIcon from '@/components/ui/Icon.vue'

export default {
    name: 'Modal',

    components: { AppIcon, GlobalEvents },

    directives: { onClickAway },

    props: {
        value: { type: Boolean, required: true },
        headline: { type: String, required: true },
        closable: { type: Boolean, default: true },
        hideFooter: { type: Boolean, default: false },
    },

    data () {
        return {
            show: this.value,
        }
    },

    watch: {
        value (value) {
            this.show = value
        },
    },

    methods: {
        hide () {
            if (this.value) {
                this.$emit('input', false)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/modal";

.modal {
    cursor: auto;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: $zindex-modal-backdrop;
}

.modal-header {
    border: none;
    padding-bottom: $spacing-unit-3;
}

.modal-body {
    padding-top: $spacing-unit-12;
}

.modal-footer {
    border: none;
}

.close {
    padding: $spacing-unit-12 !important;
    color: $color-text-default;

    @include interaction {
        color: $primary-color;
    }
}
</style>
